import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectExportApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'projectExport'
  }

}